<app-sub-navigation></app-sub-navigation>

<section *ngIf="flags.isMapButtonVisible" data-test-id="wrap-map-btn" class="visual py-5 text-center text-white">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="heading-holder py-3 mb-4 text-uppercase">
          <h1 class="m-0">
            {{ 'MAP_HOPE_AND_HEALTH_HINT' | translate }}
          </h1>
        </div>
        <p class="mb-4">{{ 'MAP_SHORT_INFO_HINT' | translate }}</p>
        <button class="btn btn-light btn-lg" data-test-id="view-map-button" (click)="toggleButtonVisibility()">
          {{ 'MAP_BTN_VIEW_MAP_HINT' | translate }}
        </button>
      </div>
    </div>
  </div>
</section>
<section class="container-login" data-test-id="map-login-form" *ngIf="!isAuthSeeMap">
  <div class="container-login-textbutton pb-5">
    <span> {{ 'LOGIN_SEE_MAP' | translate }} </span>
    <button
      class="btn btn-primary text-white nav-login"
      type="submit"
      data-test-id="login-form-login-btn"
      (click)="navLoginPage()"
    >
      {{ 'LOGIN_FORM_SUBMIT_BTN' | translate }}
    </button>
  </div>
</section>
<section class="map-section" data-test-id="map-section" *ngIf="mapState">
  <app-map-container
    [flags]="flags"
    [markers]="displayedMarkers"
    [mapState]="mapState"
    [zoomOptions]="zoomOptions"
    [mapMarker]="mapMarker"
    [mediator]="mediator"
    [initialLocationProvider]="mapFlow"
    [isAdminSession]="isAdminSession"
    (mapChanged)="onChanges($event)"
  ></app-map-container>
  <ng-container *ngIf="flags.isNotCovidTab">
    <div
      *ngIf="!flags.isSearchBlockVisible"
      data-test-id="search-container"
      class="search-button-container"
      @searchBlockShowTrigger
    >
      <button
        class="btn btn-outline-primary text-dark search-btn"
        type="button"
        data-test-id="search-btn"
        (click)="toggleSearchBlockVisibility()"
      >
        <div class="d-inline-block align-middle">
          <svg-icon src="assets/icons/icon-search.svg" class="icon-search"> </svg-icon>
        </div>
        {{ 'MAP_SEARCH_BLOCK_SEARCH_BUTTON_HINT' | translate }}
      </button>
    </div>
    <div
      *ngIf="flags.isSearchBlockVisible"
      data-test-id="search-block-container"
      class="search-block-container p-2"
      @searchBlockShowTrigger
    >
      <app-search-block
        class="card h-100"
        [flags]="flags"
        [isAdminSession]="isAdminSession"
        [markers]="mapMarkers.areaMarkers"
        [searchBlockContent]="searchBlockContent"
        [goToBlockContent]="goToBlockContent"
        [mediator]="mediator"
        (closeSearchBlock)="onCloseSearchBlock($event)"
        (resetForm)="onResetForm()"
        (formSubmitted)="onSearchFormSubmitted($event)"
        (goToSubmitted)="onMapGotoFormSubmitted($event)"
      ></app-search-block>
    </div>
    <app-selected-filters-block
      *ngIf="flags.isSearchFormSubmitted"
      class="selected-filters-container"
      [attr.is_search_block_visible]="flags.isSearchBlockVisible"
      [mapState]="mapState"
    ></app-selected-filters-block>
  </ng-container>
</section>

<app-users-total *ngIf="statistics$ | async as statistics" [statistics]="statistics" [flags]="flags"> </app-users-total>

<section data-test-id="healthy-connections" class="visual style01 py-5 text-center text-white">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-md-7">
        <div class="text-uppercase text-center py-4">
          <h1 class="m-0" [innerHtml]="'MAP_BUILD_HEALTHY_CONNECTIONS_HINT' | translate"></h1>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="about-us" data-test-id="about-us">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6 offset-lg-6">
        <h2 class="my-5">{{ 'MAP_ABOUT_1L2C_HINT' | translate }}</h2>
        <div class="text-block pt-4 px-5">
          <p [innerHtml]="'MAP_ABOUT_1L2C_DESCRIPTION_PART1' | translate"></p>
          <p [innerHtml]="'MAP_ABOUT_1L2C_DESCRIPTION_PART2' | translate"></p>
        </div>
      </div>
    </div>
  </div>
</section>
